export default __webpack_public_path__ + "static/productdiscovery_old-b23e7e9fe2b583cb8212744c164ec5a6.jpg";